import {
  formatUploadArticleDateTime,
  getUploadArticleRecordTimestamp,
} from "../../../utils/uploadArticlesDateUtils";

export default function UploadArticlesPendingRetriesTable({
  items,
  pagination,
}) {
  const totalPages =
    pagination && pagination.totalItems > 0
      ? Math.ceil(pagination.totalItems / pagination.pageSize)
      : 1;
  const showPagination =
    pagination && pagination.totalItems > pagination.pageSize;

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full bg-white border border-gray-200 rounded-lg">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 border-b border-gray-200 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              ASIN
            </th>
            <th className="px-6 py-3 border-b border-gray-200 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Fecha registro
            </th>
            <th className="px-6 py-3 border-b border-gray-200 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Categoría
            </th>
            <th className="px-6 py-3 border-b border-gray-200 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Retries
            </th>
            <th className="px-6 py-3 border-b border-gray-200 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Result
            </th>
            <th className="px-6 py-3 border-b border-gray-200 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Estado
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {items.map((item, index) => (
            <tr
              key={item.id ?? `${item.asin}-${index}`}
              className="hover:bg-gray-50"
            >
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {item.asin || "N/A"}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 tabular-nums">
                {formatUploadArticleDateTime(
                  getUploadArticleRecordTimestamp(item)
                ) ?? "N/A"}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {item.category_name || "N/A"}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 tabular-nums">
                {item.retries ?? "N/A"}
              </td>
              <td
                className="px-6 py-4 text-sm text-gray-900 max-w-md break-words"
                title={item.result || undefined}
              >
                {item.result || "N/A"}
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-red-200 text-red-700">
                  Pendiente
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {showPagination && (
        <div className="flex flex-wrap items-center justify-between gap-3 mt-4 px-1">
          <p className="text-sm text-gray-600">
            Mostrando{" "}
            {(pagination.currentPage - 1) * pagination.pageSize + 1}–
            {Math.min(
              pagination.currentPage * pagination.pageSize,
              pagination.totalItems
            )}{" "}
            de {pagination.totalItems}
          </p>
          <div className="flex flex-wrap items-center gap-2">
            <button
              type="button"
              disabled={pagination.currentPage <= 1}
              onClick={() => pagination.onPageChange(1)}
              className="px-3 py-1.5 text-sm rounded-md border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Primera
            </button>
            <button
              type="button"
              disabled={pagination.currentPage <= 1}
              onClick={() =>
                pagination.onPageChange((p) => Math.max(1, p - 1))
              }
              className="px-3 py-1.5 text-sm rounded-md border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Anterior
            </button>
            <span className="text-sm text-gray-700 tabular-nums px-1">
              Página {pagination.currentPage} de {totalPages}
            </span>
            <button
              type="button"
              disabled={pagination.currentPage >= totalPages}
              onClick={() =>
                pagination.onPageChange((p) =>
                  Math.min(totalPages, p + 1)
                )
              }
              className="px-3 py-1.5 text-sm rounded-md border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Siguiente
            </button>
            <button
              type="button"
              disabled={pagination.currentPage >= totalPages}
              onClick={() => pagination.onPageChange(totalPages)}
              className="px-3 py-1.5 text-sm rounded-md border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Última
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
